const addClasses = (ele, ...classes) => ele.classList.add(...classes);

export default addClasses;
